export const CACHE_SIZE = 200;
export const LLT_EXPIRED = -1;
// time to live defaults to 2 hours
export const DEFAULT_TTL = 2 * 60 * 60 * 1000;
